import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getCurrentUser } from "../services/getCurrentUser";

const SideMenu = () => {
  const navigate = useNavigate();
  const [userdata, setUserData] = useState({});
  useEffect(() => {
    const userData = getCurrentUser();
    console.log(userData);
    setUserData(userData);
  }, []);
  const logoutHandler = () => {
    localStorage.clear();
    navigate("/");

  };
  return (
    <div className="side__menu">
      <div className="profile">
        <div className="image">
          <img
            src={userdata?.photo||"/profile.png"}
            alt=""
          />
        </div>
        <h3>{userdata?.name}</h3>
        <h6>Frontend Developer</h6>
      </div>
      <div className="personal__info">
        <div className="grid">
          <p>Email</p>
          <h4>{userdata?.email}</h4>
        </div>
        <div className="grid">
          <p>Employee ID</p>
          <h4>-</h4>
        </div>
        <div className="grid">
          <p>Blood Group</p>
          <h4>-</h4>
        </div>
        <div className="grid">
          <p>Contact Number</p>
          <h4>+91 7034327244</h4>
        </div>
        <div className="logout" onClick={logoutHandler}>
          <img src="/logout.svg" alt="" />
          logout
        </div>
      </div>
    </div>
  );
};
export default SideMenu;
